import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { gallist } from "../services/login";
import ImageURL from "../imageurl";

export const Home = () => {
  const navigate = useNavigate();
  const [glist, setGList] = useState([]);
  const [gpath, setGPath] = useState("");
  useEffect(() => {
    localStorage.clear();
    gallist().then((res) => {
      if (res.status === true) {
        setGList(res.data.details);
        setGPath(ImageURL + res.data.path);
      }
    });
  },[]);
  return (
    <Fragment>
      <div className="page">
        {/* <div id="preloader">
            <div id="status">&nbsp;</div>
          </div> */}

        <div id="masthead" className="headerhome ttm-header-style-01">
          <div className="ttm-header-wrap">
            <div
              id="ttm-stickable-header-w"
              className="ttm-stickable-header-w clearfix"
            >
              {/* <div className="ttm-topbar-wrapper ttm-textcolor-white clearfix">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div className="ttm-topbar-content">
                        <ul className="top-contact text-left">
                          <li>
                            <i className="fa fa-map-marker ttm-textcolor-skincolor"></i>
                            Ponnazhagar Mahal, SikkandarSavadi, Koodal Nagar,
                            Madurai - 625018
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div id="site-header-menu" className="site-header-menu">
                <div className="site-header-menu-inner ttm-stickable-header">
                  <div className="container">
                    <div className="row">
                      <div className="col">
                        <div
                          id="site-navigation"
                          className="site-navigation d-flex flex-row"
                        >
                          <div className="site-branding mr-auto">
                            <a
                              className="home-link"
                              href="https://frameophotography.in/"
                              title="Sylin Beauty"
                              rel="home"
                            >
                              <img
                                id="logo-img"
                                className="img-center lazyload"
                                src={require("../assets/img/frameo.png")}
                                alt="logo"
                              />
                            </a>
                          </div>
                          <div className="ttm-menu-toggle">
                            <input type="checkbox" id="menu-toggle-form" />
                            <label
                              htmlFor="menu-toggle-form"
                              className="ttm-menu-toggle-block"
                            >
                              <span className="toggle-block toggle-blocks-1"></span>
                              <span className="toggle-block toggle-blocks-2"></span>
                              <span className="toggle-block toggle-blocks-3"></span>
                            </label>
                          </div>
                          <ul className="top-contact text-right">
                          <li> Albums
                            {/* <i className="fa fa-map-marker ttm-textcolor-skincolor"></i>
                            Ponnazhagar Mahal, SikkandarSavadi, Koodal Nagar,
                            Madurai - 625018 */}
                          </li>
                        </ul>

                          {/* <nav id="menu" className="menu">
                            <ul className="dropdown">
                              <li className="">
                                <a href="https://wedding.frameophotography.in/index.html">Home</a>
                              </li>
                              <li>
                                <a href="https://wedding.frameophotography.in/aboutus.html">ABOUT</a>
                              </li>
                              <li>
                                <a href="https://wedding.frameophotography.in/location.html">LOCATION</a>
                              </li>
                              <li className="active">
                                <a href="https://wedding.frameophotography.in/gallery.html">PHOTOS</a>
                              </li>
                              <li>
                                <a href="https://wedding.frameophotography.in/live.html">LIVE</a>
                              </li>
                              <li>
                                <a href="https://wedding.frameophotography.in/videos.html">VIDEOS</a>
                              </li>
                            </ul>
                          </nav> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="ttm-page-title-row">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="title-box text-center">
                  <div className="page-title-heading">
                    <h1>Gallery</h1>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <a title="Homepage" href="https://wedding.frameophotography.in/index.html">
                        home
                      </a>
                    </span>
                    <span className="ttm-bread-sep">&nbsp; / &nbsp;</span>
                    <span>Gallery</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="site-main mt-5">
          <section className="ttm-row gallery-section clearfix" >
          {/* <div className="background-overlay" style={{backgroundImage: `url(${require("../assets/img/Wedding.jpg")})`, backgroundSize: 'cover'}}> */}
     <div className="container" style={{zIndex: 9}}>
              <div className="row">
                {glist.map((data, i) => {
                  return (
                    <div className="col-md-4 col-sm-6" key={i}>
                      <div className="featured-imagebox style2">
                        <div className="ttm-post-thumbnail featured-thumbnail">
                          <img
                            className="img-fluid"
                            src={gpath + data.photo}
                            alt="image"
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
  {/* </div> */}
           
          </section>
        </div>

        {/* <section className="call-buton">
          <a className="cc-calto-action-ripple" href="https://wedding.frameophotography.in/live.html">
            <i className="fa fa-video-camera"></i>
            <span className="num">WATCH LIVE</span>
          </a>
        </section> */}
        <footer className="footer widget-footer clearfix">
          <div className="first-footer">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-7 col-sm-9 m-auto text-center">
                  <div className="footer-logo">
                    <img
                      id="footer-logo-img"
                      className="img-center"
                      src={require("../assets/img/frameo.png")}
                      // src="images/footer-logo.png"
                      alt=""
                    />
                  </div>
                  <h4 className="textwidget widget-text ttm-textcolor-white">
                    {" "}
                    Engraving UR Moments
                  </h4>

                  <a
                    href="https://frameophotography.in/"
                    target="_blank"
                    className="ttm-btn ttm-btn-bgcolor-skincolor"
                  >
                    Visit Site
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="bottom-footer-text">
            <div className="container">
              <div className="row copyright">
                <div className="col-md-9">
                  <div className="ttm-textcolor-white">
                    <span>
                      Copyright &copy; 2024&nbsp;
                      <a
                        className="ttm-textcolor-skincolor"
                        href="https://frameophotography.in/"
                      >
                        FrameO
                      </a>{" "}
                      by{" "}
                      <a href="https://amytechnologies.in/" target="_blank">
                        AMY Technologies
                      </a>
                    </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="d-flex flex-row align-items-center justify-content-end social-icons">
                    <ul className="social-icons list-inline">
                      <li>
                        <a
                          href="https://www.facebook.com/FRAMEOMK?mibextid=ZbWKwL"
                          className=" tooltip-top"
                          data-tooltip="Facebook"
                          target="_blank"
                        >
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://frameophotography.in"
                          className=" tooltip-top"
                          data-tooltip="Website"
                          target="_blank"
                        >
                          <i className="fa fa-globe"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/frameophotography?igsh=MzRlODBiNWFlZA=="
                          className=" tooltip-top"
                          data-tooltip="Instagram"
                          target="_blank"
                        >
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://youtube.com/@frameophotography?si=G7GON8dDHn57dnq0"
                          className=" tooltip-top"
                          data-tooltip="Youtube"
                          target="_blank"
                        >
                          <i className="fa fa-youtube-play"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>

       
      </div>
    </Fragment>
  );
};
